<template>
  <div id="editor-menu">
    <a :href="getUrl(1)" class="item">
      <img :src="imageUrl('lovers', 1)" alt="Pre páry" />
    </a>
    <a :href="getUrl(3)" class="item">
      <img :src="imageUrl('music', 3)" alt="Spotify" />
    </a>
    <a :href="getUrl(4)" class="item">
      <img :src="imageUrl('custom', 4)" alt="Vlastné" />
    </a>
    <a :href="getUrl(5)" class="item">
      <img :src="imageUrl('photo', 5)" alt="Fotografia a koláže" />
    </a>
    <a :href="getUrl(2)" class="item">
      <img :src="imageUrl('insta', 2)" alt="Instagram" />
    </a>
    <a :href="getUrl(7)" class="item">
      <img :src="imageUrl('illustration', 7)" alt="Ilustrácia" />
    </a>
  </div>
</template>
<script>
import { url, language } from "../../../../helpers";
import { mapGetters } from "vuex";
import useRoutes from "../../../useRoutes";

export default {
  computed: {
    ...mapGetters({
      product: "product/getProduct",
      products: "cart/getProducts",
    }),
  },
  methods: {
    getUrl(categoryId) {
      const product = this.products.find(
        (product) => product.category_id === categoryId
      )

      return this.productDetail(product.slug);
    },
    imageUrl(category, categoryId) {
      const fileName =
        this.product.category_id === categoryId ? "icon" : "greyicon";

      return url(`/img/product/${category}/${this.lang}_${fileName}.jpg`);
    },
  },
  setup() {
    const lang = language();
    const { productDetail } = useRoutes();

    return {
      url,
      lang,
      productDetail,
    };
  },
};
</script>
